/* eslint-disable react/jsx-no-target-blank */
import React from 'react';
import PropTypes from 'prop-types';
import { Field, FormikProvider, ErrorMessage } from 'formik';
import { Background } from 'layout';
import { Button, Checkbox, InputPhone, ValidatedRecaptcha } from 'ui';
import Card from 'react-bootstrap/Card';
import styles from './OnboardingForm.module.css';
import OnboardingBanner from '../OnboardingBanner';
import { AgreeLabel, AuthorizationLabel } from './TermsAndConditions';
import { Input } from 'ui/FormInputs';
import { Box } from '@material-ui/core';
import useOnboardingForm from './useOnboardingForm';

const OnboardingForm = ({ setToken }) => {
    const { formik, captchaRef } = useOnboardingForm({ setToken });
    const { values, errors, touched, handleChange, handleSubmit } = formik;

    return (
        <Background className={styles.onboardingCard} wrapper={styles.wrapper}>
            <Card.Header className={styles.cardHeader}>
                <Card.Title className={styles.title}>Initiate Identity Verification</Card.Title>
            </Card.Header>
            <FormikProvider value={formik}>
                <form onSubmit={handleSubmit} className={styles.OnboardingForm}>
                    <OnboardingBanner />
                    <Card.Body className={styles.cardBody}>
                        <Box className={styles.inputWrapper}>
                            <Input
                                label="Enter your company email to receive a one-time passcode (OTP) *"
                                name="email"
                                type="text"
                                value={values.email}
                                onChange={handleChange}
                                placeholder="you@example.com"
                                error={touched.email && Boolean(errors.email)}
                                helperText={touched.email && errors.email}
                            />
                            <InputPhone
                                label="Enter the phone number of the person being verified *"
                                placeholder="Enter phone number"
                                name="phoneNumber"
                                value={values.phoneNumber}
                                onChange={handleChange}
                                error={touched.phoneNumber && Boolean(errors.phoneNumber)}
                                helperText={touched.phoneNumber && errors.phoneNumber}
                                form={formik}
                            />
                        </Box>
                        <Box className={styles.checkBoxRow}>
                            <Field component={Checkbox} name="accept" />
                            <label htmlFor="accept" className={styles.checkBoxLabel}>
                                <AgreeLabel />
                            </label>
                        </Box>
                        <ErrorMessage
                            name="accept"
                            component="p"
                            className={styles.checkBoxError}
                        />
                        <Box className={styles.checkBoxRow}>
                            <Field component={Checkbox} name="passcode" />
                            <label htmlFor="passcode" className={styles.checkBoxLabel}>
                                <AuthorizationLabel />
                            </label>
                        </Box>
                        <ErrorMessage
                            name="passcode"
                            component="p"
                            className={styles.checkBoxError}
                        />
                        <Field
                            render={(fieldProps) => (
                                <ValidatedRecaptcha {...fieldProps} ref={captchaRef} />
                            )}
                            name="captcha"
                        />
                    </Card.Body>
                    <Card.Footer bsPrefix={styles.cardFooter}>
                        <Button block className={styles.proceedBtn} variant="primary" type="submit">
                            Proceed
                        </Button>
                    </Card.Footer>
                </form>
            </FormikProvider>
        </Background>
    );
};

OnboardingForm.propTypes = {
    setToken: PropTypes.func.isRequired,
};

export default OnboardingForm;
